import React from 'react';
import { FOOTER_LINKS, SOCIAL_LINKS } from '../data';
import logo from '../images/logo.webp';
import './Footer.css';

const SocialIcon = ({ platform }) => {
  const icons = {
    facebook: (
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M9.5 3H11V1H9C7.3 1 6 2.3 6 4v1H4v2h2v7h2.5V7h2l.5-2H8.5V4c0-.6.4-1 1-1z" fill="currentColor"/>
      </svg>
    ),
    instagram: (
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
        <rect x="2" y="2" width="12" height="12" rx="3.5" stroke="currentColor" strokeWidth="1.3"/>
        <circle cx="8" cy="8" r="3" stroke="currentColor" strokeWidth="1.3"/>
        <circle cx="11.5" cy="4.5" r="0.8" fill="currentColor"/>
      </svg>
    ),
    youtube: (
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
        <rect x="1" y="3.5" width="14" height="9" rx="2" stroke="currentColor" strokeWidth="1.3"/>
        <path d="M6.5 5.5l4 2.5-4 2.5V5.5z" fill="currentColor"/>
      </svg>
    ),
    twitter: (
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M2 3h3l2.5 3.5L10.5 3H14l-4.5 5L14 13h-3L8.5 9.5 5.5 13H2l4.5-5.5L2 3z" fill="currentColor"/>
      </svg>
    ),
    whatsapp: (
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
        <circle cx="8" cy="8" r="7" stroke="currentColor" strokeWidth="1.3"/>
        <path d="M4 12l1-2.5A4 4 0 1 1 7 11.5L4 12z" stroke="currentColor" strokeWidth="1" fill="none"/>
        <path d="M6 7c.5 1 1.5 2 2.5 2" stroke="currentColor" strokeWidth="1" strokeLinecap="round"/>
      </svg>
    ),
  };
  return icons[platform] || null;
};

export default function Footer() {
 
  

  return (
    <footer className="footer" id="stores">
      <div className="footer__top">
        <div className="footer__top-inner">
          {/* Logo column */}
          <div className="footer__col footer__col--logo">
            <div className="footer__logo-icon">
              {/* <div className="footer__logo-icon">
                <svg width="38" height="38" viewBox="0 0 38 38" fill="none">
                  <circle cx="19" cy="19" r="17" stroke="#C9973A" strokeWidth="1.5"/>
                  <path d="M19 9L23 16L19 23L15 16Z" fill="#C9973A" opacity="0.9"/>
                  <circle cx="19" cy="19" r="3.5" fill="#C9973A"/>
                </svg>
              </div>
              <div className="footer__logo-text">
                <span className="footer__logo-jks">JKS</span>
                <span className="footer__logo-jewels">JEWELS</span>
              </div> */}
              <img src={logo} alt="JKS Jewels"/>
            </div>

            {/* Social links */}
            <div className="footer__socials">
              {SOCIAL_LINKS.map((s) => (
                <a
                  key={s.platform}
                  href={s.href}
                  className="footer__social-link"
                  aria-label={s.platform}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <SocialIcon platform={s.platform} />
                </a>
              ))}
            </div>

            <p className="footer__made-with">
              Made By Grow Bharat Media
              
            </p>
          </div>

          {/* FAQ column */}
          {/* <div className="footer__col">
            <h4 className="footer__col-title">Frequently Asked Questions</h4>
            <ul className="footer__links">
              <li><a href="#faq" className="footer__link">Are diamonds certified for purity?</a></li>
              <li><a href="#faq" className="footer__link">Are ornaments HUID 916 hallmarked?</a></li>
              <li><a href="#faq" className="footer__link">Lifetime maintenance for jewellery?</a></li>
              <li><a href="#faq" className="footer__link">Does JKS offer online shopping?</a></li>
              <li><a href="#faq" className="footer__link">Current offers or discounts?</a></li>
              <li><a href="#faq" className="footer__link">Gold rate at JKS Jewels today?</a></li>
            </ul>
          </div> */}

          {/* Other column */}
          <div className="footer__col">
            <h4 className="footer__col-title">Other</h4>
            <ul className="footer__links">
              {FOOTER_LINKS.other.map((link) => (
                <li key={link.label}>
                  <a href={link.href} className="footer__link">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

         
          {/* Address column */}
<div className="footer__col footer__col--address">
  <h4 className="footer__col-title">Our Offices</h4>

  <div className="footer__address">
     <p>
      <strong>Chennai</strong><br/>
      1st Floor, 5A, No.46,<br/>
      Hiravat Complex,<br/>
      Hanumantharayan Koil Street,<br/>
      Chennai – 600003
    </p>

    <p>
      <strong>Bangalore</strong><br />
      110-112,JKS GOLDEN TOWER,First Floor<br />
      Nagarathpet Main Road,<br />
      D S Temple,Nagarathpet,Bangalore – 560002<br />
      <a
        href="https://maps.app.goo.gl/HaMsedbHVMpNGE5M8"
        target="_blank"
        rel="noopener noreferrer"
      >
        View Map
      </a>
    </p>
    
   
  </div>
</div>
<div className="footer__col footer__col--address">
  {/* <h4 className="footer__col-title">Our Offices</h4>*/}

  <div className="footer__address">
   
    
   

    <p>
      <strong>Mumbai</strong><br />
      Room No.25, 3rd Floor,<br />
      Plot No.124/130, 118,<br />
      Kansara Chawal, Kalbadevi Road,<br />
      Bhuleshwar, Mumbai – 400002
    </p>
  </div>
</div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="footer__bottom">
        <p className="footer__copyright">
          All rights reserved ❤ 2026. JKS Jewels
        </p>
      </div>
    </footer>
  );
}
